import axios from "axios";

const API = axios.create({
  baseURL: "https://api.displaymaxindia.in/"
});

export default API;
